import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {NotificationsService, ProjectService} from '@catcore/services';
import {ROLE, UserService} from '@catcore/services/user.service';
import {GuiZoneWithIcon, Project, ProjectGgwDevice} from '@catcore/types/api-v2';
import {CanvasState} from '@catdetails/components/project-lopa-positions/canvas-state';
import {
  CanvasDrawable,
  EntityBackedCanvasDrawable,
} from '@catdetails/components/project-lopa-positions/drawable/canvas-drawable';
import {Icon} from '@catdetails/components/project-lopa-positions/drawable/icon';
import {Polygon} from '@catdetails/components/project-lopa-positions/drawable/polygon';
import {GenericResourceService} from '@catfeatures/services/generic-resource.service';
import {StyleType} from '@catui/types';
import * as lodash from 'lodash';
import {ConfirmationService} from 'primeng/primeng';
import {Subscription} from 'rxjs/Subscription';
import {isNullOrUndefined} from 'util';

enum GGW_MODES { AUDIO = 'AUDIO', VIDEO = 'VIDEO' }

/**
 * Component to enter and check LOPA icon positions
 */
@Component({
  templateUrl: './project-lopa-positions.component.html',
  styleUrls: ['./project-lopa-positions.scss'],
})
export class ProjectLopaPositionsComponent
  implements OnInit, OnDestroy {
  static AUDIO_IMAGE_BASE64 = 'data:image/svg+xml;base64,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';
  static VIDEO_IMAGE_BASE64 = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4yIiBiYXNlUHJvZmlsZT0idGlueSIgaWQ9IkViZW5lXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiDQoJIHg9IjBweCIgeT0iMHB4IiB3aWR0aD0iNDBweCIgaGVpZ2h0PSI0MHB4IiB2aWV3Qm94PSIwIDAgNDAgNDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHBhdGggZmlsbD0iI0Y3RDI0NyIgZD0iTTIwLjAwMiwxLjU2NWMtMTAuMTE5LDAtMTguMzUyLDguMjMyLTE4LjM1MiwxOC4zNTJjMCwxMC4xMTcsOC4yMzIsMTguMzQ4LDE4LjM1MiwxOC4zNDgNCgljMTAuMTE3LDAsMTguMzQ5LTguMjMsMTguMzQ5LTE4LjM0OEMzOC4zNTIsOS43OTgsMzAuMTE5LDEuNTY1LDIwLjAwMiwxLjU2NXoiLz4NCjxnPg0KCTxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik0yNi4xMzMsMjguMjE4SDEzLjg5NWMtMC4yNzUsMC0wLjUsMC4yMjQtMC41LDAuNXMwLjIyNSwwLjUsMC41LDAuNWgxMi4yMzhjMC4yNzcsMCwwLjUtMC4yMjQsMC41LTAuNQ0KCQlTMjYuNDEsMjguMjE4LDI2LjEzMywyOC4yMTh6Ii8+DQoJPHBhdGggZmlsbD0iI0ZGRkZGRiIgZD0iTTExLjUwOCwxNi44NjhjMC4xMjcsMCwwLjI1NC0wLjA0OCwwLjM1Mi0wLjE0NWwxLjAyLTEuMDA2YzAuMTk1LTAuMTkzLDAuMTk3LTAuNTExLDAuMDA0LTAuNzA3DQoJCWMtMC4xOTUtMC4xOTYtMC41MTItMC4xOTgtMC43MDctMC4wMDRsLTEuMDIsMS4wMDZjLTAuMTk1LDAuMTkzLTAuMTk3LDAuNTExLTAuMDA0LDAuNzA3DQoJCUMxMS4yNSwxNi44MTgsMTEuMzc5LDE2Ljg2OCwxMS41MDgsMTYuODY4eiIvPg0KCTxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik0xMS40ODUsMTkuNjI0YzAuMTI5LDAsMC4yNTYtMC4wNDksMC4zNTQtMC4xNDZsMy43NzMtMy43NzJjMC4xOTUtMC4xOTUsMC4xOTUtMC41MTIsMC0wLjcwNw0KCQlzLTAuNTEyLTAuMTk1LTAuNzA3LDBsLTMuNzczLDMuNzcyYy0wLjE5NSwwLjE5NS0wLjE5NSwwLjUxMiwwLDAuNzA3QzExLjIyOSwxOS41NzUsMTEuMzU4LDE5LjYyNCwxMS40ODUsMTkuNjI0eiIvPg0KCTxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik0zMC45OTIsMTEuODUzSDkuMDM2Yy0wLjU1MywwLTEsMC40NDctMSwxdjEyLjcxM2MwLDAuNTUzLDAuNDQ3LDEsMSwxaDIxLjk1N2MwLjU1MywwLDEtMC40NDcsMS0xVjEyLjg1Mw0KCQlDMzEuOTkyLDEyLjMsMzEuNTQ1LDExLjg1MywzMC45OTIsMTEuODUzeiBNMjkuOTkyLDI0LjU2NUgxMC4wMzZWMTMuODUzaDE5Ljk1N1YyNC41NjV6Ii8+DQo8L2c+DQo8L3N2Zz4NCg==';
  static AUDIO_IMAGE: HTMLImageElement;
  static VIDEO_IMAGE: HTMLImageElement;
  private subscriptions: Subscription[] = [];
  ggwMode: GGW_MODES = GGW_MODES.AUDIO;
  ggwModes = GGW_MODES;
  project: Project = null;

  projectInitialized = false;

  private canvasState: CanvasState;
  private zonePolygons: Array<Polygon<GuiZoneWithIcon>> = [];
  private seatIcons: Array<Icon<GuiZoneWithIcon>> = [];
  private ggwDeviceIcons: Array<Icon<ProjectGgwDevice>> = [];
  role = ROLE;
  styleType = StyleType;
  zoneColor = '#2364c8';

  static preLoadImages() {
    this.AUDIO_IMAGE = new Image();
    this.AUDIO_IMAGE.src = this.AUDIO_IMAGE_BASE64;
    this.VIDEO_IMAGE = new Image();
    this.VIDEO_IMAGE.src = this.VIDEO_IMAGE_BASE64;
  }
  @ViewChild(`lopaCanvas`) set setLopaCanvas(canvas: ElementRef) {
    if (!this.canvasState && canvas) {
      this.initCanvas(canvas.nativeElement);
    }
  }

  constructor(private projectService: ProjectService,
              private notificationService: NotificationsService,
              private confirmationService: ConfirmationService,
              private sanitizer: DomSanitizer,
              private userService: UserService,
              private genericResourceService: GenericResourceService) {
  }

  ngOnInit() {
    // Get GuiZones and GgwDevices
    this.subscriptions.push(
      this.projectService
        .getCurrentProject()
        .subscribe((project: Project) => {
          if (isNullOrUndefined(project) || isNullOrUndefined(project.id)) {
            this.project = null;
          } else {
            this.project = project;
            this.subscriptions.push(
              this.projectService.getAllGuiZones(project).subscribe((zones: GuiZoneWithIcon[]) => {
                zones.forEach((zone: GuiZoneWithIcon) => {
                  let drawable = null;
                  if (zone.type === 'zone') {
                    drawable = new Polygon<GuiZoneWithIcon>(zone,
                      (poly: Polygon<GuiZoneWithIcon>) => {
                        if (/^(\d+,\d+;?)+$/.test(poly.entity.lopa_pos)) {
                          poly.allPoints = poly.entity.lopa_pos.split(';').map((xy) => xy.split(',').map((n) => Number.parseInt(n)));
                        }
                      },
                      (poly: Polygon<GuiZoneWithIcon>) => {
                        poly.entity.lopa_pos = poly.allPoints.map((point: number[]) => point.join(',')).join(';');
                      },
                      (poly) => this.zoneColor,
                      (poly) => poly.allPoints.map((point: number[]) => point.join(',')).join(';') !== poly.entity.lopa_pos,
                    );
                    this.zonePolygons.push(drawable);
                    this.canvasState.addDrawable(drawable);
                  } else if (zone.type === 'seat') {
                    drawable = new Icon<GuiZoneWithIcon>(zone, (entity) => (entity.icon || null),
                      (icon: Icon<GuiZoneWithIcon>) => { icon.x = icon.entity.image_x; icon.y = icon.entity.image_y; },
                      (icon: Icon<GuiZoneWithIcon>) => { icon.entity.image_x = icon.x; icon.entity.image_y = icon.y; },
                      (icon: Icon<GuiZoneWithIcon>) => icon.entity.image_x !== icon.x || icon.entity.image_y !== icon.y,
                      );
                    this.seatIcons.push(drawable);
                    this.canvasState.addDrawable(drawable, 1);
                  }
                });
                this.canvasState.invalidate();
              }),
            );
            this.subscriptions.push(
              this.projectService.getAllGgwDevices(project, true, true).subscribe((ggwDevices: ProjectGgwDevice[]) => {
                ggwDevices.forEach((ggwDevice: ProjectGgwDevice) => {
                  // const icon = new Icon<ProjectGgwDevice>(ggwDevice.icon_x[0] || 0, ggwDevice.icon_y[0] || 0, ggwDevice, (entity) => entity._embedded.gui_image.file || null);
                  const icon = new Icon<ProjectGgwDevice>(ggwDevice,
                    (device: ProjectGgwDevice) => this.ggwMode === GGW_MODES.AUDIO ? ProjectLopaPositionsComponent.AUDIO_IMAGE : ProjectLopaPositionsComponent.VIDEO_IMAGE,
                    (ggwIcon: Icon<ProjectGgwDevice>) => {
                    const index = this.findIconRoleIndex(ggwIcon.entity);
                    if (index !== -1) {
                        ggwIcon.x = Number.parseInt(ggwIcon.entity.icon_x[index]);
                        ggwIcon.y = Number.parseInt(ggwIcon.entity.icon_y[index]);
                      }
                    },
                    (ggwIcon: Icon<ProjectGgwDevice>) => {
                      let index = this.findIconRoleIndex(ggwIcon.entity);
                      if (index === -1) {
                        // Add audio / video role
                        index = ggwIcon.entity.icon_roles.push(this.ggwMode.toLowerCase()) - 1;
                      }
                      ggwIcon.entity.icon_x[index] = ggwIcon.x.toString();
                      ggwIcon.entity.icon_y[index] = ggwIcon.y.toString();
                    },
                    (ggwIcon: Icon<ProjectGgwDevice>) => {
                      const index = this.findIconRoleIndex(ggwIcon.entity);
                      if (index === -1) {
                        return ggwIcon.x !== 0 || ggwIcon.y !== 0;
                      }
                      return ggwIcon.entity.icon_x[index] !== ggwIcon.x.toString() || ggwIcon.entity.icon_y[index] !== ggwIcon.y.toString();
                    },
                  );
                  this.ggwDeviceIcons.push(icon);
                  this.canvasState.addDrawable(icon, 2);
                });
                this.canvasState.invalidate();
              }),
            );
          }
          this.projectInitialized = true;
        }),
    );
  }

  private findIconRoleIndex(ggwDevice: ProjectGgwDevice): number {
    if (!ggwDevice.icon_roles || ggwDevice.icon_roles.length === 0) {
      return -1;
    }
    const index = ggwDevice.icon_roles.findIndex((value, index1, obj) => value === this.ggwMode.toLowerCase());
    if (index === -1) {
      return ggwDevice.icon_roles.findIndex((value, index1, obj) => value === 'all');
    }
    return index;
  }

  initCanvas(canvas: HTMLCanvasElement) {
    console.log('Init Canvas...');
    const image = new Image();
    image.onload = () => {
      this.canvasState = new CanvasState(canvas, image);
    };
    image.src = this.project.lopa;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.subscriptions = [];
  }

  saveAll() {
    [this.zonePolygons, this.seatIcons, this.ggwDeviceIcons].forEach((ds: Array<EntityBackedCanvasDrawable<any>>) => {
      ds.forEach((d) => {
        if (d.hasChanged(d)) {
          this.updateEntity(d);
        }
      });
    });
  }
  resetAll() {
    [this.zonePolygons, this.seatIcons, this.ggwDeviceIcons].forEach((ds: Array<EntityBackedCanvasDrawable<any>>) => {
      ds.forEach((d) => {
        if (d.hasChanged(d)) {
          d.updateFromEntity(d);
        }
      });
    });
    this.canvasState.invalidate();
  }
  // Helper methods for templates
  cIcon<T>(drawable: CanvasDrawable<T>) {
    return drawable as Icon<T>;
  }
  cZone(zonePoly: any) {
    return zonePoly as Polygon<GuiZoneWithIcon>;
  }
  cSeat(seatIcon: any) {
    return seatIcon as Icon<GuiZoneWithIcon>;
  }
  cGgwDevice(ggwDevice: any) {
    return ggwDevice as Icon<ProjectGgwDevice>;
  }
  isIcon(drawable: CanvasDrawable<any>) {
    return drawable && drawable instanceof Icon;
  }
  isPolygon(drawable: CanvasDrawable<any>) {
    return drawable && drawable instanceof Polygon;
  }

  updateEntity(entityDrawable: EntityBackedCanvasDrawable<any>) {
    const entityBackup = lodash.cloneDeep(entityDrawable.entity);
    const resourceService = this.genericResourceService.findServiceForResource(entityDrawable.entity._links.self.href);
    const handleError = (error) => {
      this.notificationService.error('Entity update failed!', error);
      entityDrawable.entity = entityBackup;
    };
    entityDrawable.updateEntity(entityDrawable);
    try {
      resourceService.save(entityDrawable.entity).subscribe(
      (value) => {},
      handleError,
      );
    } catch (e) {
      handleError(e);
    }
  }

  rowClick(drawable: CanvasDrawable<any>) {
    if (!this.canvasState.selection || this.canvasState.selection !== drawable) {
      this.canvasState.selection = drawable;
      this.canvasState.invalidate();
    }
  }

  addPointToPolygon(zone: Polygon<GuiZoneWithIcon>) {
    let x = 0;
    let y = 0;
    if (zone.allPoints.length > 0) {
      x = zone.allPoints[zone.allPoints.length - 1][0];
      y = zone.allPoints[zone.allPoints.length - 1][1];
    }
    zone.allPoints.push([x, y]);
    this.canvasState.invalidate();
  }

  private switchGgwDeviceMode(mode: GGW_MODES) {
    this.ggwMode = mode;
    this.ggwDeviceIcons.forEach((ggwDevice) => ggwDevice.updateFromEntity(ggwDevice));
    this.canvasState.invalidate();
  }

  changeGgwMode(mode: GGW_MODES, event) {
    if (this.ggwMode !== mode) {
      if (this.ggwDeviceIcons.some((ggwDevice) => ggwDevice.hasChanged(ggwDevice))) {
        event.preventDefault();
        this.confirmationService.confirm({
          header: 'GGW device mode',
          message: 'Do you really want to switch the GGW device mode? All current changes to GGW devices are lost.',
          accept: () => {
            this.switchGgwDeviceMode(mode);
          },
        });
      } else {
        this.switchGgwDeviceMode(mode);
      }
    }
  }
}
ProjectLopaPositionsComponent.preLoadImages();



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/project-details/components/project-lopa-positions/project-lopa-positions.component.ts